// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Pagination } from 'swiper';
// import 'swiper/css';
// import 'swiper/css/autoplay';
// import 'swiper/css/pagination';

// // Local Images from assets
// import img1 from '../assets/1.png'; // Personalized Dashboards
// import img3 from '../assets/3.png'; // Class Behavior Analysis
// import img5 from '../assets/5.png'; // AI-Powered Attendance
// import img7 from '../assets/7.png'; // Health Care
// import img8 from '../assets/8.png'; // 360° Communication
// import img9 from '../assets/9.png'; // Video Conferencing

// const slides = [
//     {
//         title: 'AI-Powered Attendance',
//         description: 'Facial recognition powered by AI ensures secure and seamless attendance.',
//         image: img5,
//     },
//     {
//         title: 'Personalized Dashboards',
//         description: 'Role-based dashboards tailored for students, faculty, and admin.',
//         image: img1,
//     },
//     {
//         title: '360° Communication',
//         description: 'Bridge the gap between school, students, and parents with smart communication tools.',
//         image: img8,
//     },
//     {
//         title: 'Analyzing Class Behavior',
//         description: 'Track student behavior like talking, laughing, or being serious to improve classroom dynamics.',
//         image: img3,
//     },
//     {
//         title: 'Health Care Monitoring',
//         description: 'Track student health records, alerts, and wellness reports directly within the ERP.',
//         image: img7,
//     },
//     {
//         title: 'Integrated Video Conferencing',
//         description: 'Host virtual classes and meetings between teachers and students within the ERP platform.',
//         image: img9,
//     },
// ];

// const FeatureCarousel = () => {
//     return (
//         <section className="py-16 px-6 md:px-16 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white">
//             <div className="max-w-6xl mx-auto text-center">
//                 <h2 className="text-4xl font-bold mb-4">✨ Key Highlights</h2>
//                 <p className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto">
//                     Discover what makes <span className="text-indigo-400 font-semibold">Isnartech ERP</span> a class apart in modern school management.
//                 </p>

//                 <Swiper
//                     spaceBetween={30}
//                     slidesPerView={1}
//                     loop={true}
//                     autoplay={{ delay: 4000 }}
//                     pagination={{ clickable: true }}
//                     modules={[Autoplay, Pagination]}
//                     className="rounded-2xl shadow-2xl"
//                 >
//                     {slides.map((slide, index) => (
//                         <SwiperSlide key={index}>
//                             <div className="relative h-[450px] w-full rounded-2xl overflow-hidden">
//                                 <img
//                                     src={slide.image}
//                                     alt={slide.title}
//                                     className="w-full h-full object-fit"
//                                 />
//                                 <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent z-10" />
//                                 <div className="absolute bottom-0 z-20 p-6 text-left w-full">
//                                     <h3 className="text-2xl md:text-3xl font-semibold text-white mb-2">{slide.title}</h3>
//                                     <p className="text-gray-200 text-sm md:text-base">{slide.description}</p>
//                                 </div>
//                             </div>
//                         </SwiperSlide>

//                     ))}
//                 </Swiper>
//             </div>
//         </section>
//     );
// };

// export default FeatureCarousel;


import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

// Images
import img1 from '../assets/1.png';
import img3 from '../assets/3.png';
import img5 from '../assets/5.png';
import img7 from '../assets/7.png';
import img8 from '../assets/8.png';
import img9 from '../assets/9.png';

const slides = [
    {
        title: 'AI-Powered Attendance',
        description: 'Facial recognition powered by AI ensures secure and seamless attendance.',
        image: img5,
    },
    {
        title: 'Personalized Dashboards',
        description: 'Role-based dashboards tailored for students, faculty, and admin.',
        image: img1,
    },
    {
        title: '360° Communication',
        description: 'Bridge the gap between school, students, and parents with smart communication tools.',
        image: img8,
    },
    {
        title: 'Analyzing Class Behavior',
        description: 'Track student behavior like talking, laughing, or being serious to improve classroom dynamics.',
        image: img3,
    },
    {
        title: 'Health Care Monitoring',
        description: 'Track student health records, alerts, and wellness reports directly within the ERP.',
        image: img7,
    },
    {
        title: 'Integrated Video Conferencing',
        description: 'Host virtual classes and meetings between teachers and students within the ERP platform.',
        image: img9,
    },
];

// const slides = [
//   {
//     title: 'AI Attendance',
//     description: 'Facial recognition for smart attendance.',
//     image: img5,
//   },
//   {
//     title: 'Dashboards',
//     description: 'Personalized for each role.',
//     image: img1,
//   },
//   {
//     title: '360° Communication',
//     description: 'Smart tools to connect parents and school.',
//     image: img8,
//   },
//   {
//     title: 'Behavior Analysis',
//     description: 'Real-time student behavior insights.',
//     image: img3,
//   },
//   {
//     title: 'Health Care',
//     description: 'Wellness reports inside the ERP.',
//     image: img7,
//   },
//   {
//     title: 'Video Classes',
//     description: 'Virtual classes built-in.',
//     image: img9,
//   },
// ];

const FeatureCarouselHero = () => {
    return (
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        loop
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Autoplay]}
        className="rounded-2xl shadow-2xl w-full h-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative w-full h-full rounded-2xl overflow-hidden group transition-all duration-300">
              {/* Image */}
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-fit transition-transform duration-500 group-hover:scale-105"
                
              />
  
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent z-10" />
  
              {/* Text Content */}
              <div className="absolute bottom-0 left-0 right-0 z-20 px-5 py-4 text-white">
                <h3 className="text-lg font-semibold">{slide.title}</h3>
                <p className="text-sm text-gray-200">{slide.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };
  
  export default FeatureCarouselHero;